import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageNotFound404 from "../../assets/images/404NotFound.png";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { ErrorWrapper } from "./_styles/ErrorWrapper";

function PageNotFound({
  heading = "Page Not Found",
  subHeading = "The page you are looking for doesn't exist.",
  message = "Please enter correct URL.",
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const source = location.pathname.split("/")[1];
  return (
    <>
      <ProgressBar showProgress={false} currentStep={0} />
      <AfterLoginLayoutWrapper>
        <ErrorWrapper className="first-child">
          <Title
            id="pageTitle"
            className="pageTitle"
            text={heading}
            visible={true}
            clickable={false}
            style={{
              fontSize: "24px",
            }}
          />
          <div
            style={{
              padding: "0px 0px",
              margin: "20px 0px 10px 0px",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={subHeading}
              style={{
                fontSize: "20px",
              }}
            />
          </div>
          <div className="image">
            <img
              height={230}
              width={"100%"}
              src={PageNotFound404}
              alt="Technical_Error"
            />
          </div>
          <div
            style={{
              padding: "0px 10px",
              margin: "10px",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={message}
              style={{
                fontSize: "20px",
              }}
            />
          </div>
        </ErrorWrapper>
        {/* <div className="bottomDiv only-btn">
          <Button
            id="ProceedBtn"
            className="Btn ProceedBtn"
            disabled={false}
            onClick={() => {
              var route = getRouteFromLoanStageService({
                source: source,
                stage: "index",
              });
              // // console.log("stage: ", customerDetails.stage);
              // console.log("route: ", route);
              navigate(`${route}`, {
                replace: true
              });
            }}
            text={"Home"}
          />
        </div> */}
      </AfterLoginLayoutWrapper>
    </>
  );
}

export default PageNotFound;
